import { createSlice } from '@reduxjs/toolkit';

export interface ScreenUiState {
  /** True while a blocking screen-limit modal should be shown. */
  limitReached: boolean;
}

const initialState: ScreenUiState = { limitReached: false };

const screenSlice = createSlice({
  name: 'screen',
  initialState,
  reducers: {
    screenLimitReached(state) { state.limitReached = true; },
    clearScreenLimit(state) { state.limitReached = false; },
  },
});

export const { screenLimitReached, clearScreenLimit } = screenSlice.actions;
export default screenSlice.reducer;
